import { UnprocessedOrderType } from '@business/pages/OrderManage/shared/types';
import { getGrayStateByToken, GRAY_AB_TOKEN } from '@utils/grayAB';
import { menuTagList } from '../../utils/getOrderMenuTags';
import { sendMessageToSubFrame, FRAME_NAME } from '../../utils/subFrames';

/** 餐饮新形态灰度 */
const UNIFIED_ORDER_GRAY = getGrayStateByToken(GRAY_AB_TOKEN.UNIFIED_ORDER);

type State = { [key in UnprocessedOrderType]: number } & { total: number };

const unprocessedOrderTypeValues = Object.keys(UnprocessedOrderType).map(
    key => (UnprocessedOrderType as { [index: string]: string })[key],
);

const isUnprocessedOrderType = (key: string): key is UnprocessedOrderType => {
    return unprocessedOrderTypeValues.includes(key);
};

const isNewUnprocessedOrderType = (key: any): key is UnprocessedOrderType => {
    // 待接单、待发配送、待出餐、异常相关、待处理退款、食安待处理订单数量加和
    const newCountMenus = [
        UnprocessedOrderType.New,
        UnprocessedOrderType.PrepLogistics,
        UnprocessedOrderType.PrepMeal,
        UnprocessedOrderType.Refund,
        UnprocessedOrderType.FoodSafeProcess4Poi,
        // 异常
        UnprocessedOrderType.MealAbnormal,
        UnprocessedOrderType.LogisticsAbnormal,
        UnprocessedOrderType.PreOrderToMeal,
        UnprocessedOrderType.Remind,
        UnprocessedOrderType.IncomeAbnormal,
        UnprocessedOrderType.Other,
        UnprocessedOrderType.OrderPreRiderOrder,
        UnprocessedOrderType.OrderPreRiderPick,
        UnprocessedOrderType.OrderLogisticsing,
    ];
    return newCountMenus.includes(key);
};

const isOldUnprocessedOrderType = (key: any): key is UnprocessedOrderType => {
    // 待接单、待发配送、待出餐、异常相关、待处理退款、食安待处理订单数量加和
    const newCountMenus = [
        UnprocessedOrderType.NewOrder,
        UnprocessedOrderType.Refund,
        UnprocessedOrderType.Remind,
        UnprocessedOrderType.PrepMeal,
        UnprocessedOrderType.DeliveryException,
        UnprocessedOrderType.Unnormal,
        UnprocessedOrderType.DutyCompensate,
        UnprocessedOrderType.LossCompensate,
        UnprocessedOrderType.PrepDelivery,
        UnprocessedOrderType.Other,
    ];
    return newCountMenus.includes(key);
};

/**
 * 各种待处理订单计数
 */
const orderCount = {
    name: 'orderCount',
    state: {
        [UnprocessedOrderType.NewOrder]: 0,
        [UnprocessedOrderType.Refund]: 0,
        [UnprocessedOrderType.Remind]: 0,
        [UnprocessedOrderType.PrepMeal]: 0,
        [UnprocessedOrderType.DeliveryException]: 0,
        [UnprocessedOrderType.Unnormal]: 0,
        [UnprocessedOrderType.DutyCompensate]: 0,
        [UnprocessedOrderType.LossCompensate]: 0,
        [UnprocessedOrderType.PrepDelivery]: 0,
        [UnprocessedOrderType.Other]: 0,

        // 履约新形态新增
        [UnprocessedOrderType.New]: 0,
        [UnprocessedOrderType.PrepLogistics]: 0,
        [UnprocessedOrderType.LogisticsAbnormal]: 0,
        [UnprocessedOrderType.Cancel]: 0,
        [UnprocessedOrderType.PreOrderToMeal]: 0,
        [UnprocessedOrderType.IncomeAbnormal]: 0,
        [UnprocessedOrderType.AfterSaleCanAppeal]: 0,
        [UnprocessedOrderType.Responsible]: 0,
        [UnprocessedOrderType.Cansun]: 0,
        [UnprocessedOrderType.FoodSafeAppealForPoi]: 0,
        [UnprocessedOrderType.OrderPreRiderOrder]: 0,
        [UnprocessedOrderType.OrderPreRiderPick]: 0,
        [UnprocessedOrderType.OrderLogisticsing]: 0,
        /** 全部待处理订单总数 */
        total: 0,
    } as State,
    reducers: {
        /** 更新订单计数（自动计算总数） */
        updateCount(
            state: State,
            payload: Partial<{ [key in UnprocessedOrderType]: string }> & {
                noticeInner?: boolean;
                forbiddenReload?: boolean;
            },
        ) {
            const newState = { ...state };
            Object.keys(payload).forEach(type => {
                if (isUnprocessedOrderType(type)) {
                    if (payload[type] === '+1') {
                        newState[type] += 1;
                    } else if (payload[type] === '-1') {
                        newState[type] = Math.max(0, newState[type] - 1);
                    } else {
                        const newCount = Number(payload[type]);
                        if (!Number.isNaN(newCount)) {
                            newState[type] = Math.max(newCount, 0);
                        }
                    }

                    /** 通知内层计数变更 */
                    if (payload.noticeInner) {
                        sendMessageToSubFrame(FRAME_NAME.HASH, {
                            handlerType: 'orderCountChangeFromParent',
                            forbiddenReload: payload.forbiddenReload || false,
                            [type]: newState[type],
                        });
                    }
                }
            });

            // 计算总数
            let newTotal = 0;
            Object.keys(newState).forEach(type => {
                if (isUnprocessedOrderType(type)) {
                    if (UNIFIED_ORDER_GRAY) {
                        // 履约新形态 tag不在menu里头不计入总数
                        if (menuTagList && menuTagList.indexOf(type) === -1) {
                            newState[type] = 0;
                        }
                        if (isNewUnprocessedOrderType(type)) {
                            newTotal += newState[type];
                        }
                    } else {
                        if (isOldUnprocessedOrderType(type)) {
                            newTotal += newState[type];
                        }
                    }
                }
            });

            return {
                ...newState,
                total: newTotal,
            };
        },
    },
    effects: () => ({}),
};

export default orderCount;
export { isUnprocessedOrderType };
